import { useState, useEffect } from 'react';
import { fetchOrganizaciones, fetchDepartamentos, request } from '../../../../shared/services/api';
import {
  modalOverlay,
  modalBox,
  fieldLabel,
  fieldInput,
  btnCancel,
  btnPrimary,
} from './persona-detail-shared';

const TIPO_ROL_OPTIONS = [
  'PROPIETARIO_PROCESO',
  'DPO',
  'OFICIAL_CUMPLIMIENTO',
  'PROPIETARIO_RIESGO',
  'AUDITOR_INTERNO',
  'RESPONSABLE_CALIDAD',
  'MIEMBRO_CONSEJO',
  'SECRETARIO_CONSEJO',
  'PERSONALIZADO',
];

export function AssignRolModal({
  personaId,
  onClose,
  onAssigned,
}: {
  personaId: string;
  onClose: () => void;
  onAssigned: () => void;
}) {
  const [tipoRol, setTipoRol] = useState('');
  const [orgs, setOrgs] = useState<Array<{ value: string; label: string }>>([]);
  const [depts, setDepts] = useState<Array<{ value: string; label: string }>>([]);
  const [orgId, setOrgId] = useState('');
  const [deptId, setDeptId] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchOrganizaciones()
      .then((r) => setOrgs((r.data ?? []).map((o) => ({ value: o.id, label: o.nombre }))))
      .catch(() => {});
    fetchDepartamentos({ porPagina: '100' })
      .then((r) => setDepts((r.data ?? []).map((d) => ({ value: d.id, label: d.nombre }))))
      .catch(() => {});
  }, []);

  const handleAssign = async () => {
    if (!tipoRol) {
      setError('Selecciona un tipo de rol');
      return;
    }
    try {
      setSaving(true);
      await request(`/apps/personas/${personaId}/roles-gobernanza`, {
        method: 'POST',
        body: JSON.stringify({
          tipoRol,
          organizacionId: orgId || undefined,
          departamentoId: deptId || undefined,
          fechaInicio: new Date().toISOString().split('T')[0],
        }),
      });
      onAssigned();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div onClick={onClose} style={modalOverlay}>
      <div onClick={(e) => e.stopPropagation()} style={modalBox}>
        <h2 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: '#0E243E' }}>
          Asignar rol de gobernanza
        </h2>
        <div style={{ marginBottom: 12 }}>
          <label style={fieldLabel}>Tipo de rol *</label>
          <select
            value={tipoRol}
            onChange={(e) => setTipoRol(e.target.value)}
            style={{ ...fieldInput, background: '#fff' }}
          >
            <option value="">-- Seleccionar --</option>
            {TIPO_ROL_OPTIONS.map((r) => (
              <option key={r} value={r}>
                {r.replace(/_/g, ' ')}
              </option>
            ))}
          </select>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px 16px',
            marginBottom: 16,
          }}
        >
          <div>
            <label style={fieldLabel}>Organizacion</label>
            <select
              value={orgId}
              onChange={(e) => setOrgId(e.target.value)}
              style={{ ...fieldInput, background: '#fff' }}
            >
              <option value="">-- Todas --</option>
              {orgs.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={fieldLabel}>Departamento</label>
            <select
              value={deptId}
              onChange={(e) => setDeptId(e.target.value)}
              style={{ ...fieldInput, background: '#fff' }}
            >
              <option value="">-- Todos --</option>
              {depts.map((d) => (
                <option key={d.value} value={d.value}>
                  {d.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {error && (
          <div
            style={{
              padding: '8px 12px',
              borderRadius: 6,
              marginBottom: 12,
              background: '#FEF2F2',
              color: '#DC2626',
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onClose} style={btnCancel}>
            Cancelar
          </button>
          <button
            onClick={handleAssign}
            disabled={saving}
            style={{ ...btnPrimary, opacity: saving ? 0.7 : 1 }}
          >
            {saving ? 'Asignando...' : 'Asignar'}
          </button>
        </div>
      </div>
    </div>
  );
}
